import request from 'superagent';

import parseJSON from 'shared-utils/src/parseJSON';
import { computeActiveFilters } from 'shared-utils/src/helpersMyCasa';
import { DEFAULT_FILTERS_CONFIGURATION } from 'shared-constants/src/filters';
import resetFilter from 'shared-utils/src/resetFilter';

import provinceShortToLongList from 'shared-constants/src/locations/provinceShortToLong';

import { getHumanFiltersV13, getHumanFiltersCountV13 } from 'shared-utils/src/getHumanFilters';
export { getHumanFiltersV13, getHumanFiltersCountV13 };

import { integerWithEuropeThousandSeparator } from '../STRINGHelpers';

import { categoryFilter } from '../../constants/restyling';

export const getFilterPlurals = (values, selected) => {
  try {
    return values.map(
      (type) => {
        if (selected.includes(type.value)) {
          return type.plural;
        }
        return null;
      },
    ).filter(Boolean);
  } catch (error) {
    console.log(`getPtypesPlurals error: ${error}`);
  }
  return selected;
};

export const getPtypesPlurals = (group, selected) => {
  const values = DEFAULT_FILTERS_CONFIGURATION.propertyTypes.values[group];
  return getFilterPlurals(values, selected);
};

export async function srpOnBackButton(uri, domain, locale, esapi, pagetype, isAgencySrp, size) {
  const proxy = await request.post('/portal-srp/api/v1/apireq/searchParamsForUrl')
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json')
    .withCredentials()
    .send({
      uri,
      domain,
      locale,
      esapi,
      pagetype,
      isAgencySrp,
      size,
    });
  return proxy.body;
}

export async function computeHowToGoBack({
  domain,
  currentLocale,
  esapi,
  fetchAgencyListingOnFiltersChange = null,
  fetchListingOnFiltersChange,
  goBack,
  pageType,
  backUriCollection,
}) {
  if (backUriCollection.length > 1) {
    const {
      uri,
      filters,
      locations,
      parentLocation,
      isPublisherHP,
      isAgencySrp,
      agencyFreetext,
    } = backUriCollection[backUriCollection.length - 2];
    const fetchParams = await srpOnBackButton(uri, domain, currentLocale, esapi, pageType, isAgencySrp);
    backUriCollection.pop();
    if (isAgencySrp) {
      fetchAgencyListingOnFiltersChange(fetchParams);
    } else {
      fetchListingOnFiltersChange(fetchParams);
    }
    return {
      action: 'smartback',
      newState: {
        filters,
        locations,
        parentLocation,
        collapsePublisherInfos: !isPublisherHP,
        agencyFreetext,
      },
      backUriCollection,
    };
  }
  return {
    action: 'browserback',
    goBack,
  };
}

export async function computeHowToGoBackOnMap({
  domain,
  currentLocale,
  esapi,
  fetchListingOnFiltersChange,
  goBack,
  pageType,
  backUriCollection,
  size,
}) {
  if (backUriCollection.length) {
    const usableCollection = [...backUriCollection];
    const { backActionConf } = usableCollection.pop();

    if (backActionConf) {
      if (backActionConf.action === 'navigate') {
        let bounds = (backActionConf.mapData && backActionConf.mapData.bounds) ? backActionConf.mapData.bounds : null;
        const prev = usableCollection[usableCollection.length - 1];
        if (prev) {
          const prevAction = prev.backActionConf?.action;
          if (prevAction && prevAction === 'draw' && prev.backActionConf?.drawingData) {
            bounds = prev.backActionConf?.drawingData?.shapeBounds;
          }
        }
        return {
          action: 'resetbounds',
          bounds,
          backUriCollection: usableCollection,
        };
      }

      if (backActionConf.action === 'draw') {
        if (backActionConf.previousShapeData) {
          return {
            action: 'revertToPreviousShape',
            activeShapes: backActionConf.drawingData.activeShapes,
            previousShapeData: backActionConf.previousShapeData,
            // drawing replaced the locations with the map locality: the previous shape (e.g. the locality polygons
            // of a q landing) needs the locations the page had before drawing, or the refetch has no q
            locations: backActionConf.locations || [],
            parentLocation: backActionConf.parentLocation || {},
            backUriCollection: usableCollection,
          };
        } else if (backActionConf.drawingData) {
          let filterToReset = { geopolygon: null };
          if (backActionConf.drawingData.action === 'around') {
            filterToReset = { geocircle: null };
          }
          if (backActionConf.drawingData.action === 'nearby') {
            filterToReset = { nearby: null };
          }

          if (backActionConf.drawingData.q) {
            filterToReset = { ...filterToReset, geobounds: null };
          }

          return {
            action: 'deleteShape',
            filterToReset,
            activeShapes: backActionConf.drawingData.activeShapes,
            bounds: backActionConf.drawingData.mapBoundsOnCreateShape,
            q: backActionConf.drawingData.q,
            locations: backActionConf.locations || [],
            parentLocation: backActionConf.parentLocation || {},
            backUriCollection: usableCollection,
          };
        }
      }

      if (backActionConf.action === 'delete' && backActionConf.drawingData) {
        return {
          action: 'recreateShape',
          drawingData: backActionConf.drawingData,
          backUriCollection: usableCollection,
        };
      }
    }

    const fetchParams = await srpOnBackButton(backActionConf.uri, domain, currentLocale, esapi, pageType, false, size);
    fetchListingOnFiltersChange(fetchParams);

    return {
      action: 'smartback',
      newState: {
        filters: backActionConf.filters,
      },
      backUriCollection: usableCollection,
    };
  } else {
    return {
      action: 'browserback',
      goBack,
    };
  }
}

export const getProvinceShortName = long => Object.keys(provinceShortToLongList).find(key => provinceShortToLongList[key] === long);

export function createTokensFromActiveFilters(filtersList, currentChannel) {
  // channel
  let channel = 'Vendita';
  if (currentChannel) {
    if (currentChannel === 'affitto') {
      channel = 'Affitto';
    } else if (currentChannel === 'affitto-breve') {
      channel = 'Affitto Breve';
    }
  }

  if (!filtersList) {
    return channel;
  }
  if (
    'propertyTypeGroup' in filtersList
    && filtersList.propertyTypeGroup
  ) {
    if (filtersList.propertyTypeGroup.toLowerCase() === 'commerciale') {
      channel += ' comm.';
    } else if (filtersList.propertyTypeGroup.toLowerCase() === 'vacanze') {
      channel += ' vacanze';
    }
  }
  // propertyTypes
  let pTypes = '';
  if ('propertyTypes' in filtersList) {
    pTypes = filtersList.propertyTypes.join(', ');
  }
  // price / mqPrice / mortgage rate
  let price = '';
  if ('priceMin' in filtersList || 'priceMax' in filtersList) {
    if ('priceMin' in filtersList) {
      price += `da ${String.fromCharCode(8364)} ${integerWithEuropeThousandSeparator(filtersList.priceMin)}`;
      if ('priceMax' in filtersList) {
        price += ` a ${String.fromCharCode(8364)} ${integerWithEuropeThousandSeparator(filtersList.priceMax)}`;
      }
    } else {
      price += `fino a ${String.fromCharCode(8364)} ${integerWithEuropeThousandSeparator(filtersList.priceMax)}`;
    }
  }
  if ('mqpriceMin' in filtersList || 'mqpriceMax' in filtersList) {
    if ('mqpriceMin' in filtersList) {
      let mq = ' al m².';
      if ('mqpriceMax' in filtersList) {
        mq = '';
      }
      price += `da ${String.fromCharCode(8364)} ${integerWithEuropeThousandSeparator(filtersList.mqpriceMin)}${mq}`;
      if ('mqpriceMax' in filtersList) {
        price += ` a ${String.fromCharCode(8364)} ${integerWithEuropeThousandSeparator(filtersList.mqpriceMax)} al m².`;
      }
    } else {
      price += `fino a ${String.fromCharCode(8364)} ${integerWithEuropeThousandSeparator(filtersList.mqpriceMax)} al m².`;
    }
  }
  if ('paymentMin' in filtersList || 'paymentMax' in filtersList) {
    if ('paymentMin' in filtersList) {
      price += `rata da ${String.fromCharCode(8364)} ${integerWithEuropeThousandSeparator(filtersList.paymentMin)}`;
      if ('paymentMax' in filtersList) {
        price += ` a ${String.fromCharCode(8364)} ${integerWithEuropeThousandSeparator(filtersList.paymentMax)}`;
      }
    } else {
      price += `rata fino a ${String.fromCharCode(8364)} ${integerWithEuropeThousandSeparator(filtersList.paymentMax)}`;
    }
  }
  // surface
  let mq = '';
  if ('mqMin' in filtersList || 'mqMax' in filtersList) {
    if ('mqMin' in filtersList) {
      mq += `da ${String.fromCharCode(8364)} ${integerWithEuropeThousandSeparator(filtersList.mqMin)} m².`;
      if ('mqMax' in filtersList) {
        mq += ` a ${String.fromCharCode(8364)} ${integerWithEuropeThousandSeparator(filtersList.mqMax)} m².`;
      }
    } else {
      mq += `fino a ${String.fromCharCode(8364)} ${integerWithEuropeThousandSeparator(filtersList.mqMax)} m².`;
    }
  }
  // rooms number
  let numRooms = '';
  if (filtersList.rooms && (filtersList.rooms.min != null || filtersList.rooms.max != null)) {
    const rMin = filtersList.rooms.min != null ? String(filtersList.rooms.min) : '';
    const rMax = filtersList.rooms.max != null ? String(filtersList.rooms.max) : '';
    if (rMin && rMax) {
      numRooms += `con da ${rMin} a ${rMax} locali `;
    } else if (rMin) {
      numRooms += `con almeno ${rMin} local${rMin === '1' ? 'e' : 'i'} `;
    } else if (rMax) {
      numRooms += `con massimo ${rMax} local${rMax === '1' ? 'e' : 'i'} `;
    }
  }

  // bathrooms number
  let numBaths = '';
  if (filtersList.bathrooms && filtersList.bathrooms.min != null) {
    numBaths += `${filtersList.bathrooms.min}+ bagni`;
  }
  // parkings number
  let parkingSpaces = '';
  if ('parkingSpaces' in filtersList) {
    parkingSpaces += `${filtersList.parkingSpaces} box`;
  }
  // heating type
  let heating = '';
  if ('heating' in filtersList) {
    heating += `riscaldamento ${filtersList.heating}`;
  }
  // garden
  let garden = '';
  if ('garden' in filtersList) {
    // garden += `${filtersList.garden.replace('-', ' ')}`;
    garden += filtersList.garden;
  }
  return {
    channel,
    pTypes,
    price,
    mq,
    numRooms,
    numBaths,
    parkingSpaces,
    heating,
    garden,
  };
}

const formatTokens = (el) => {
  let text = el.name;
  if (el.levels) {
    switch (el.level) {
      case 6:
        text += ' (provincia)';
        break;
      case 9:
        text += ` (${getProvinceShortName(el.levels.L6)})`;
        break;
      case 10: // area
        text += ` - ${el.levels.L9} (${getProvinceShortName(el.levels.L6)})`;
        break;
      default:
        text = el.name;
    }
  }
  return text;
};

export const formatMobileHeaderFiltersString = (filtersList, currentChannel, alwaysIncludePTypes, excludeChannel = false) => {
  let count = 0;
  const limit = 3;
  const {
    channel,
    pTypes,
    price,
    mq,
    numRooms,
    numBaths,
    parkingSpaces,
    heating,
    garden,
  } = createTokensFromActiveFilters(filtersList, currentChannel);
  const string = [];
  if (!excludeChannel) {
    string.push(channel);
  }
  if (price !== '') {
    count += 1;
    string.push(price);
  }
  if (alwaysIncludePTypes && pTypes !== '') {
    string.push(pTypes);
  }
  if (price === '' && mq !== '') {
    count += 1;
    string.push(mq);
  }
  if (numRooms !== '') {
    count += 1;
    string.push(numRooms);
  }
  if (numBaths !== '' && count < limit) {
    count += 1;
    string.push(numBaths);
  }
  if (parkingSpaces !== '' && count < limit) {
    count += 1;
    string.push(parkingSpaces);
  }
  if (heating !== '' && count < limit) {
    count += 1;
    string.push(heating.replace(',', ' o '));
  }
  if (garden !== '' && count < limit) {
    count += 1;
    string.push(`giardino ${garden.replace(',', ' o ')}`);
  }
  if (string.length === 1 && pTypes !== '' && !alwaysIncludePTypes) {
    string.push(pTypes);
  }
  return string.join(' | ');
};

export const extractTokensAndFilters = (tokens, filters, alwaysIncludePTypes) => {
  const localitiesArray = tokens && tokens.length > 0 ? tokens.map(el => formatTokens(el)) : ['Ovunque (tutte le località)'];
  const filtersString = formatMobileHeaderFiltersString(computeActiveFilters(filters).activeFiltersList, filters.tr, alwaysIncludePTypes);
  return { localitiesArray, filtersString };
};

export const saveRecentSearchesEntry = (tokens, filters, uri, localStorageKey) => {
  const { localitiesArray, filtersString } = extractTokensAndFilters(tokens, filters, false);
  const recentSearchEntry = {
    localities: localitiesArray.join(', '),
    filters: filtersString,
    uri,
  };
  const recentSearches = window.localStorage.getItem(localStorageKey) !== '' && window.localStorage.getItem(localStorageKey) !== null ? parseJSON(window.localStorage.getItem(localStorageKey)) : [];
  const isAlreadySaved = recentSearches.filter(rs => rs.uri === uri);
  if (isAlreadySaved.length > 0) {
    let alreadySavedIndex = null;
    recentSearches.forEach((rs, index) => { if (rs.uri === uri) alreadySavedIndex = index; });
    recentSearches.splice(alreadySavedIndex, 1);
  }
  recentSearches.unshift(recentSearchEntry);
  if (recentSearches.length > 5) {
    recentSearches.pop();
  }
  window.localStorage.setItem(localStorageKey, JSON.stringify(recentSearches));
};

export const createLabel = (value) => {
  const usableValue = value === 'case-vacanza' ? 'case' : value;

  let categoryConf = categoryFilter.filter(item => item.slug === usableValue)[0];
  if (typeof categoryConf === 'undefined') {
    const filterOptionWithChildren = categoryFilter.filter(item => 'children' in item)[0];
    if (filterOptionWithChildren) {
      const { children } = filterOptionWithChildren;
      // eslint-disable-next-line prefer-destructuring
      categoryConf = (children || []).filter(item => item.slug === usableValue)[0];
    }
  }
  /**
   * https://sentry.io/organizations/casait/issues/3426466194/?project=5222733&query=is%3Aunresolved
   * 
   * se non riesco a recuperare la label dal file di conf tanto peggio, lascio vuoto ma evito l'errore
   * potrebbe essere risolta dall'utilizzo del propertyTypeGroup quando la category non è definita
   * 
   */
  if (categoryConf) {
    return categoryConf.label === 'Immobili e attività commerciali' ? 'Imm. e att. comm.' : categoryConf.ctaLabel;
  }
  return '';
};

/**
 * reset the filters to their default values
 * @param {filters} filters
 * @param {function} updateFilters
 * @param {function} forceMobileUpdate 
 */
export const resetSearchFilters = ({ filters, updateFilters, forceMobileUpdate }) => {
  const defaultFilters = { ...filters };
  Object.keys(DEFAULT_FILTERS_CONFIGURATION).forEach((name) => resetFilter(name, defaultFilters));

  updateFilters({ ...defaultFilters, poi: null }, forceMobileUpdate);
};

export const isBannerStickyLargeShowable = () => {
  const tmpLSAppDownload = localStorage.getItem('_downloadAppBannerStickyLarge');
  const lsAppDownload = parseJSON(tmpLSAppDownload);
  if (lsAppDownload) {
    const isFirstClosure = lsAppDownload.type === 'firstClosure';
    if (isFirstClosure) {
      return true;
    }
    return false;
  }
  return true;
};

export const normalizeSRPUrl = (computedUrl, publisherRegion = false) => {
  let uri = computedUrl.replace(new RegExp('[àáâãäå]', 'g'), 'a');
  uri = uri.replace(new RegExp('[èéêë]', 'g'), 'e');
  uri = uri.replace(new RegExp('[òóôõö]', 'g'), 'o');
  uri = uri.replace(new RegExp('[ìíîï]', 'g'), 'i');
  uri = uri.replace(new RegExp('[ùúûü]', 'g'), 'u');
  uri = uri.replace(/'/g, ' ');
  uri = uri.replace(/,/g, '%2C');
  if (publisherRegion) {
    uri = uri.replace(/ /g, '%20');
  } else {
    uri = uri.replace(/ /g, '+');
  }
  uri = uri.replace(/\+%2C/gi, '%2C');
  return uri;
};

export const searchPublisherParentName = (pub) => {
  if (pub?.isAgentPro && pub?.publisherParent) {
    return pub?.publisherParent?.name || null;
  }
  return null;
};

export const isMapSearch = locations => locations.length && locations[0].level === 999;
export const isDrawonMapSearch = (locations, filters) => isMapSearch(locations) && (filters.geopolygon || filters.geocircle);

export const showLicenceTypeGroupsButton = (filters = {}) => {
  const cat = filters.propertyTypeGroup || '';
  return cat === 'commerciale';
};

export const showOfficeTypeButton = (filters = {}) => {
  const cat = filters.propertyTypeGroup || '';
  const channel = filters.tr || '';
  return cat === 'ufficio' && channel === 'affitto';
};


// export const showLicenceContractTypeGroupsButton = (filters = {}) => {
//   const channel = filters.channel || '';
//   const cat = filters.propertyTypeGroup || '';
//   const ptypes = filters.propertyTypes || [];
//   if (channel === 'vendita' && cat === 'commerciale') {
//     return !ptypes.length || (ptypes.length === 1 && ptypes[0] !== 'Negozio/Locale commerciale') || ptypes.length > 1;
//   }

//   return false;
// };
